import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme/contract.css';

export const root = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
});

export const note = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
});

export const error = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.bright.status.error,
});

export const list = style({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  maxHeight: 240,
  overflowY: 'auto',
  border: `1px solid ${vars.surface.border.subtle}`,
  borderRadius: vars.spacing.borderRadius.lg,
});

export const row = style({
  display: 'flex',
  justifyContent: 'space-between',
  gap: vars.spacing.gap.sm,
  padding: `${vars.spacing.gap.xs} ${vars.spacing.gap.sm}`,
  fontSize: vars.typography.fontSize.xs,
});

export const meta = style({
  fontVariantNumeric: 'tabular-nums',
  color: vars.typography.textColor.tertiary,
});
